import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../domain/licence-draft.validation';

const selectMyLicence = (state: RootState) => state.myLicence;

export const selectLicence = (state: RootState) => selectMyLicence(state).licence;
export const selectDraft = (state: RootState) => selectMyLicence(state).draft;
export const selectLoadStatus = (state: RootState) => selectMyLicence(state).loadStatus;
export const selectSaveStatus = (state: RootState) => selectMyLicence(state).saveStatus;
export const selectError = (state: RootState) => selectMyLicence(state).error;
export const selectValidationErrors = (state: RootState) => selectMyLicence(state).validationErrors;

export const selectIsSaving = (state: RootState) => selectMyLicence(state).saveStatus === 'saving';
export const selectLoadFailed = (state: RootState) =>
  selectMyLicence(state).loadStatus === 'failed';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);
